import type { Role } from './types.js';

// Role tiers, mirroring infra/firestore.rules and the callables' assertOrgRole
// lists. The rules/functions are the real enforcement; this is the single
// source the UI uses to hide tabs and controls a role can't use (so a page is
// never shown just to fail with "insufficient permissions").
export const OWNER_ADMIN: readonly Role[] = ['owner', 'admin'];
export const MANAGER_PLUS: readonly Role[] = ['owner', 'admin', 'manager'];
export const COORDINATOR_PLUS: readonly Role[] = ['owner', 'admin', 'manager', 'coordinator'];
export const ANY_ROLE: readonly Role[] = ['owner', 'admin', 'manager', 'coordinator', 'staff'];

export function hasRoleIn(role: Role | null | undefined, allowed: readonly Role[]): boolean {
  return !!role && allowed.includes(role);
}

// Which roles may open each org-scoped page (by router route name). Pages not
// listed are open to every member.
export const ROUTE_ROLES: Record<string, readonly Role[]> = {
  // Staff only use My Offers / Time Clock / My Account (and see open
  // positions on My Offers) — the dashboard and gig pages carry detail they
  // don't need.
  Dashboard: COORDINATOR_PLUS,
  GigsList: COORDINATOR_PLUS,
  GigDetail: COORDINATOR_PLUS,
  PeopleList: COORDINATOR_PLUS,
  RateCardsList: COORDINATOR_PLUS,
  VenuesList: COORDINATOR_PLUS,
  TimesheetReview: COORDINATOR_PLUS,
  ClientsList: MANAGER_PLUS,
  PayrollList: MANAGER_PLUS,
  Settings: OWNER_ADMIN,
};

export function canAccessRoute(routeName: string | symbol | null | undefined, role: Role | null | undefined): boolean {
  const allowed = typeof routeName === 'string' ? ROUTE_ROLES[routeName] : undefined;
  return !allowed || hasRoleIn(role, allowed);
}
